import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../redux/slice/snackbar';

const NetworkStatus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Function to handle online/offline events
    const handleOnline = () => {
      // Optionally, you can dispatch a snackbar for coming back online
      dispatch(showSnackbar({ message: 'Back online!', severity: 'success' }));
    };

    const handleOffline = () => {
      // Dispatch snackbar when offline
      dispatch(showSnackbar({ message: 'Network Unavailable', severity: 'warning' }));
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [dispatch]); // Add dispatch as a dependency

  return null; // This component does not need to render anything
};

export default NetworkStatus;
